import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      process.env.NODE_ENV === 'development' ? (
        <SignInPage {...props} auto providers={['guest']} />
      ) : (
        <SignInPage
          {...props}
          auto
          providers={[
            {
              id: 'microsoft',
              title: 'Entra',
              message: 'Sign in using Entra',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    appVisualizerPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
